import { HelixUser } from '../../../data/datatypes';

export const helixUserToAuthor = ({ email } = new HelixUser()) => email.split('@')[0];
